import { CircularProgress } from '@material-ui/core';
import { FC } from 'react';
import { createAdminPageStyles } from '../../style';
import { RESOURCE_KIND_META, RESOURCE_KIND_ORDER } from '../resourceKinds';
import { ResourceItem, ResourceKind } from '../types';
import ResourcePicker from './ResourcePicker';

export interface ResourceSection {
  kind: ResourceKind;
  title?: string;
  catalog: ResourceItem[];
  selected: ResourceItem[];
  showStatus?: boolean;
  hideIfEmpty?: boolean;
}

interface ResourceSectionsProps {
  loading?: boolean;
  heading?: string;
  emptyHint?: string;
  sections: ResourceSection[];
  onToggle: (kind: ResourceKind, item: ResourceItem, checked: boolean) => void;
  onRemove: (kind: ResourceKind, id: number) => void;
}

const useStyles = createAdminPageStyles();

const ResourceSections: FC<ResourceSectionsProps> = ({
  loading = false,
  heading,
  emptyHint,
  sections,
  onToggle,
  onRemove,
}) => {
  const classes = useStyles();
  const orderedSections = RESOURCE_KIND_ORDER.map(kind =>
    sections.find(section => section.kind === kind)
  ).filter((section): section is ResourceSection => Boolean(section));
  const visibleSections = orderedSections.filter(
    section => !(section.hideIfEmpty ?? true) || section.catalog.length > 0
  );
  const hasAny = visibleSections.length > 0;

  if (loading) {
    return (
      <div className={classes.loader}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div>
      {heading ? <h2 className={classes.sectionTitle}>{heading}</h2> : null}
      {!hasAny && emptyHint ? <p className={classes.emptyHint}>{emptyHint}</p> : null}
      {visibleSections.map(section => {
        const meta = RESOURCE_KIND_META[section.kind];
        return (
          <ResourcePicker
            key={section.kind}
            title={section.title || meta.title}
            icon={meta.Icon}
            catalog={section.catalog}
            selected={section.selected}
            showStatus={section.showStatus}
            onToggle={(item, checked) => onToggle(section.kind, item, checked)}
            onRemove={id => onRemove(section.kind, id)}
          />
        );
      })}
    </div>
  );
};

export default ResourceSections;
